<template>
  <div>
    <notifications group="notification" position="bottom right" />

    <div class="row">
      <div class="col-md-9">
        <div class="card card-custom card-sticky" id="kt_page_sticky_card">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Add New Attribute</h3>
            </div>
            <CardToolbar
              @submitEvent="submit"
              back-text="Back to list"
              back-url="/products-attributes/list"
              button-text="Create Attribute"
            />
          </div>
          <div class="card-body">
            <!--begin::Form-->
            <form class="form">
              <div class="form-group">
                <label for="attributeTitle">Title</label>
                <input
                  v-model="attribute.title"
                  id="attributeTitle"
                  class="form-control form-control-solid"
                  placeholder="Enter Attribute title"
                />
              </div>
            </form>
            <!--end::Form-->
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card card-custom">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Options</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>Parent</label>
              <select-field
                v-model="attribute.parent"
                :options="filteredAttributes"
                label-key="title"
                :searchable="true"
                placeholder="Select parent attribute"
              >
                <template #option="{ option }">
                  <span v-if="option.parent">-- {{ option.title }}</span>
                  <span v-else
                    ><span
                      class="label label-lg label-light-primary label-inline"
                      >{{ option.productCategory.title }}</span
                    >
                    {{ option.title }}
                  </span>
                </template>
              </select-field>
            </div>
            <div class="form-group">
              <label>Related to</label>
              <select-field
                v-model="attribute.productCategory"
                :options="filteredCategories"
                label-key="title"
                :searchable="true"
                placeholder="Select parent attribute"
              >
                <template #option="{ option }">
                  <span v-if="option.parent">-- {{ option.title }}</span>
                  <span v-else>{{ option.title }}</span>
                </template>
              </select-field>
            </div>
            <div class="form-group">
              <label>Is group</label>
              <MCSwitch
                @checkedEvent="toggleIsGroup"
                classes="switch-icon float-right"
                name="isPublish"
                :is-checked="attribute.isGroup"
              />
            </div>
            <div class="form-group">
              <label>Position</label>
              <input
                type="number"
                v-model.number="attribute.position"
                class="form-control form-control-sm form-control-solid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import CardToolbar from '@/view/content/components/card-toolbar/CardToolbar'
import ApiService from '@/core/services/api.service'
import MCSwitch from '@/view/content/components/switch/MCSwitch'
import SelectField from '@/view/content/components/select-field/SelectField.vue'

export default {
  name: 'NewProductCategory',
  components: {
    SelectField,
    CardToolbar,
    MCSwitch,
  },
  data() {
    return {
      attribute: {
        title: null,
        parent: null,
        productCategory: null,
        position: 1,
        isGroup: false,
      },
      attributes: [],
      parentAttributes: [],
      childrenAttributes: [],
      filteredAttributes: [],
      parentCategories: [],
      childrenCategories: [],
      filteredCategories: [],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'All Attributes', route: '/categories/list' },
      { title: 'Add New' },
    ])

    this.getAttributes('/attributes', '?itemsPerPage=1000').then(({ data }) => {
      this.attributes = [...data['hydra:member']]

      this.parentAttributes = this.attributes.filter(
        (attribute) => attribute.parent === undefined
      )
      this.childrenAttributes = this.attributes.filter(
        (attribute) => attribute.parent !== undefined
      )

      this.parentAttributes.forEach((parentAttribute) => {
        this.filteredAttributes.push(parentAttribute)
        this.childrenAttributes.forEach((childrenAttribute) => {
          if (childrenAttribute.root['@id'] === parentAttribute.root) {
            this.filteredAttributes.push(childrenAttribute)
          }
        })
      })
    })

    this.getCategories(
      '/product_categories',
      '?order[createdAt]=desc&itemsPerPage=1000'
    ).then(({ data }) => {
      this.categories = [...data['hydra:member']]

      this.parentCategories = this.categories.filter(
        (category) => category.parent === undefined
      )
      this.childrenCategories = this.categories.filter(
        (category) => category.parent !== undefined
      )

      this.parentCategories.forEach((parentCategory) => {
        this.filteredCategories.push(parentCategory)
        this.childrenCategories.forEach((childrenCategory) => {
          if (childrenCategory.root['@id'] === parentCategory.root) {
            this.filteredCategories.push(childrenCategory)
          }
        })
      })
    })
  },
  methods: {
    toggleIsGroup() {
      this.attribute.isGroup = !this.attribute.isGroup
    },
    async submit() {
      this.postAttribute(this.attribute)
        .then(() => {
          this.$notify({
            group: 'notification',
            type: 'success',
            title: 'Attribute success added',
          })
          setTimeout(() => {
            this.$router.push({ name: 'products-attributes-list' })
          }, 500)
        })
        .catch(() => {
          this.$notify({
            group: 'notification',
            type: 'error',
            title: 'Attribute error',
          })
        })
    },
    async postAttribute(entity) {
      return await ApiService.post('/attributes', entity)
    },
    async getAttributes(resource, slug = '') {
      try {
        return await ApiService.get(resource, slug)
      } catch (e) {
        throw new Error(e)
      }
    },
    async getCategories(resource, slug = '') {
      try {
        return await ApiService.get(resource, slug)
      } catch (e) {
        throw new Error(e)
      }
    },
  },
}
</script>
